import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import FormHelperText from '@mui/material/FormHelperText';
//
import { Editor, EditorProps } from '../editor';

// ----------------------------------------------------------------------

interface Props extends EditorProps {
  name: string;
}

export default function RHFEditor({ name, helperText, ...other }: Props) {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  const values = watch();

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      // dirty-guard: normalisation — clears the editor's empty-paragraph artifact, which
      // is not something the user chose, so a reseed should stay free to refresh it.
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const helperNode: React.ReactNode =
          !!error || helperText ? (
            <FormHelperText error={!!error} sx={{ px: 2 }}>
              {error ? error?.message : helperText}
            </FormHelperText>
          ) : null;

        return (
          <Editor
            value={field.value}
            onChange={field.onChange}
            error={!!error}
            helperText={helperNode}
            {...other}
          />
        );
      }}
    />
  );
}
